import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1251.45 447.883L1120 316.432H1280C1456.73 316.432 1600 459.701 1600 636.432H1706.67C1706.67 400.791 1515.64 209.766 1280 209.766H1120.03L1254.37 75.4247L1178.94 0L915.833 263.111L1176.03 523.307L1251.45 447.883Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1280 853.333C1280 735.513 1184.49 640 1066.67 640H213.333C95.5126 640 0 735.513 0 853.333V1706.67C0 1824.49 95.5126 1920 213.333 1920H1066.67C1184.49 1920 1280 1824.49 1280 1706.67V853.333Z",
  fillRule: "evenodd"
}));

var IconRotateLeftSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconRotateLeftSolid, _Component);

  var _super = _createSuper(IconRotateLeftSolid);

  function IconRotateLeftSolid() {
    _classCallCheck(this, IconRotateLeftSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconRotateLeftSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRotateLeft",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRotateLeftSolid.displayName = "IconRotateLeftSolid";
  return IconRotateLeftSolid;
}(Component);

IconRotateLeftSolid.glyphName = 'rotate-left';
IconRotateLeftSolid.variant = 'Solid';
IconRotateLeftSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRotateLeftSolid;
export { IconRotateLeftSolid };